import {
    handleRequestGet,
    handleRequestPost,
    handleRequestPut
} from '../axios';
import { parseResult, parseSubmitResult } from './GeneralFunc';
import {logMessage} from '../../components/utils.js';

export const heartbeat = async () => {
    let url = '/sess/heartbeat';
    let result = await handleRequestGet(url, {});
    logMessage('heartbeat', result);
    return result;
};

export const getSessAck = async (isLiveQuotes=false,hasFocus = true) => {
    let url = '/sess/ack';

    //live quote
    if(isLiveQuotes){
       // console.log("hasFocus",hasFocus);
        if(hasFocus == true){
           // console.log('Browser focused');
            if (document.visibilityState === 'visible') {
               // console.log('Tab is currently active');
                url+= "?mode=extend"
            } else {
               // console.log('Tab is currently inactive');
            }
        }
         
    }

    //get full response included header
    let result = await handleRequestGet(url, {}, true);

    try {

        if(result && result.data){
            logMessage('result sess/ack', result);
            let paresedResult = JSON.parse(result.data);
            result.data = paresedResult;

   
        }
        // logMessage(paresedResult)
        return result;
    } catch (error) {
        console.log(error);
    }
};

export const getSessFeedAuth = async () => {
    let url = '/sess/feed/auth';
    let result = await handleRequestGet(url, {});
    logMessage('sessFeedAuth', result);

    return parseResult(result) || {};
};

export const changePassword = async ({ old_password, new_password,type=0 }: any) => {
    let url = '/sess/password';
    let param = { old_password, new_password,type  };
    logMessage(param);
    let result = await handleRequestPut(url, param);
    logMessage('change password response');
    logMessage(result);
//   console.log("param",param)
//     console.log("result",result)

    return parseSubmitResult(result);
};

export const changeSecretAnswer = async ({ password, answers }: any) => {
    let url = '/sess/secret_answer';
    let param = { password, answers };
    logMessage(param);
    let result = await handleRequestPost(url, param);
    logMessage('changeSecretAnswer response');
    logMessage(result);

    return parseSubmitResult(result);
};

export const sessForgetPassword = async ({ email, nric }: any) => {
    let url = '/sess/forgot_password';
    let param = { email, nric };
    let result = await handleRequestPost(url, param);

    logMessage(param);
    logMessage('forgot password response');
    logMessage(result);

    return parseSubmitResult(result);
};

export const sessValidateForgetPassword = async ({ reset_token }: any) => {
    let url = '/sess/reset_password/validate';
    let param = { reset_token };
    let result = await handleRequestPost(url, param);
    return parseSubmitResult(result);
};

export const sessUpdateForgetPassword = async ({
    password,
    reset_token
}: any) => {
    let url = '/sess/reset_password';
    let param = { password, reset_token };
    let result = await handleRequestPost(url, param);

    logMessage(param);
    logMessage('forgot password response');
    logMessage(result);

    return parseSubmitResult(result);
};

export const agreeTnc = async (ids:any) => {
    let url = '/sess/tnc/agree';
    let param = {
        "tnc": ids
    };
    let result = await handleRequestPost(url, param);

    logMessage(param);
    logMessage('agreeTnc');
    logMessage(result);

    return parseSubmitResult(result);
};


export const forgetUserID = async ({identity,email}:any,recaptchaToken = null) => {
    let url = '/sess/forgot_userid';
    let param = { identity, email };
    let result = await handleRequestPost(url, param,recaptchaToken);

    logMessage(param);
    logMessage('forgot_userid');
    logMessage(result);

    return parseSubmitResult(result);
};

export const resetPassword = async ({password}:any,recaptchaToken = null) => {
    let url = '/sess/reset/password';
    let param = { password };
    let result = await handleRequestPost(url, param,recaptchaToken);

    logMessage(param);
    logMessage('resetPassword');
    logMessage(result);

    return parseSubmitResult(result);
};

export const unblockAccount = async ({password}:any,recaptchaToken = null) => {
    let url = '/sess/reset/unblock';
    let param = {  };
    let result = await handleRequestPost(url, param,recaptchaToken);

    logMessage(param);
    logMessage('unblockAccount');
    logMessage(result);

    return parseSubmitResult(result);
};

export const requestTAC = async ({
    username,
    nric,
    passport,
    business_registration_no,
    email,
    phone
}:any,recaptchaToken= null) => {
    let url = '/tac/request';
    let param = { 
        scope:"reset",
        username,
        nric,
        passport,
        business_registration_no,
        email,
        phone
    };
    let result = await handleRequestPost(url, param, recaptchaToken);

    logMessage(param);
    logMessage('requestTAC');
    logMessage(result);

    return parseSubmitResult(result);
};


export const verifyTAC = async ({
    code
}:any) => {
    let url = '/tac/verify';
    let param = { 
        code
    };
    let result = await handleRequestPost(url, param);

    logMessage(param);
    logMessage('verifyTAC');
    logMessage(result);

    return parseSubmitResult(result);
};
